module.exports = __webpack_public_path__ + "static/img/Bachelor_010473.18db110.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010473.jpg
// module id = 172
// module chunks = 0